import { patchSearchCache } from "@/apis/table/route";
import { PatchSearchCacheRequest } from "@/apis/table/types";
import { useTableId } from "@/components/mapping/hooks";
import queries from "@/queries";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useWorkbookId } from "../use-workbook";

export { useLogDsdDsdCompareDownload } from "./use-dsd-dsd-compare-log";

export const usePatchSearchCache = ({
  callback,
  useInvalidateQueries = true,
}: {
  callback?: () => void;
  useInvalidateQueries?: boolean;
}) => {
  const {
    data: workbookId,
    isLoading: isWorkbookIdLoading,
    isError: isWorkbookIdError,
  } = useWorkbookId();
  const {
    data: tableId,
    isLoading: isTableIdLoading,
    isError: isTableIdError,
  } = useTableId();
  const queryClient = useQueryClient();
  const result = useMutation({
    mutationFn: ({ request }: { request: PatchSearchCacheRequest }) => {
      const tableIdKey = tableId.tableId;
      if (!workbookId) {
        throw new Error("Workbook ID is not found");
      }
      if (!tableIdKey) {
        throw new Error("Table ID is not found");
      }
      return patchSearchCache(workbookId, tableIdKey, request);
    },
    onSuccess: (data, variables) => {
      if (!workbookId) {
        throw new Error("Workbook ID is not found");
      }

      const tableIdKey = tableId.tableId;
      if (!tableIdKey) {
        throw new Error("Table ID is not found");
      }
      if (useInvalidateQueries) {
        queryClient.invalidateQueries({
          queryKey: queries
            .workbook(workbookId)
            ._ctx.tables(tableIdKey)
            ._ctx.taxonomy().queryKey,
        });
      }
      callback?.();
    },
  });

  return {
    ready:
      !isWorkbookIdLoading &&
      !isWorkbookIdError &&
      !isTableIdLoading &&
      !isTableIdError,
    ...result,
  };
};
